import constant from "../../../../../constants/constant";
import { getDropdownValue } from "../../../../../constants/utils";
import { AddInvoiceData, ProductData } from "../interface";
import { EditInvoiceDetail } from "./interface";

interface HandleEditDataProps {
  response: EditInvoiceDetail;
  setRegionCode: (value: number) => void;
  setInvoiceData: (value: AddInvoiceData) => void;
  setProductData: (value: ProductData[]) => void;
}

export const useEditData = () => {
  const handleEditData = ({
    response,
    setProductData,
    setInvoiceData,
    setRegionCode,
  }: HandleEditDataProps) => {
    const customProduct: ProductData[] = response.product_details.map(
      (item, index) => {
        const {
          product,
          quantity = 0,
          total_price = 0,
          cost_amount = 0,
          gst_amount = 0,
          discount_percent = 0,
          product_type_gst_percentage
        } = item;
        const initialCost = cost_amount / (1 - (discount_percent * 0.01)) 
        const discountAmount = (discount_percent / 100) * initialCost;
        const subtotalAmount = (initialCost - discountAmount) * quantity ;
        const grandTotalAmount = subtotalAmount + gst_amount;

        return {
          ...product,
          sum_qty: quantity,
          sum_total_price: total_price,
          cost_amount:0,
          qty: quantity,
          total_price,
          gst_amount:gst_amount !== 0 ? gst_amount : (product_type_gst_percentage*initialCost)/100,
          srp_amount: product?.product_srp,
          custom_index: index,
          additional_keys: {
            cost_amount:initialCost,
            discount_amount: discountAmount,
            discount_percentage: discount_percent,
            qty: quantity,
            subtotal_amount: subtotalAmount,
            gst_amount,
            grand_total_amount: grandTotalAmount,
            total_product_with_case: product?.product_with_case ? quantity : 0,
          },
        };
      }
    );

    const tempInvoiceData: AddInvoiceData = {
      invoice_id: response.invoice_id_display,
      supplier_invoice_number: response.supplier_invoice_number,
      supplier_invoice_date: response.supplier_invoice_date,
      category: getDropdownValue(constant.INVOICE_CATEGORY, response.category),
      actual_invoice: String(response.actual_invoice),
      remark: response.remark,
      attachments: response.attachments ?? [],
      store_id: {
        label: response.physical_store.store_name,
        value: response.physical_store.id,
        store_code: "",
      },
      supplier_id: response?.supplier
        ? {
          label: response?.supplier?.supplier_name,
          value: response?.supplier?.id,
          gst_type: response?.supplier?.gst_type,
        }
        : null,
      invoice_file: [],
    };
    setProductData(customProduct);
    setInvoiceData(tempInvoiceData);
    setRegionCode(
      response?.physical_store?.region ?? constant.STORE_REGION.INDIA
    );
  };

  return {
    handleEditData,
  };
};
